<template>
  <div  :id="id"  :style="setStyle" class="contentBlok">
    <div class="container">
    <h2  :style="getColors">{{ title }}</h2>
    <p :style="getColors" v-html="text"></p>
  </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    textColor: {
      type: String,
      default: 'black'
    },
    backgroundColor: {
      type: String,
      default: 'white'
    },
    setStyle:{
      type: String,
      default: null
    },
    text: {
      type: String,
      default: null
    },
    id:{
      type:String,
      defaul:null
    }

  },
  computed: {
    getColors() {
      return {
        color: this.textColor,
        backgroundColor: this.backgroundColor
      }
    }
  }
}

</script>
<style scoped>
template{
  padding: 50px 10px;
  background:#2ecc71;
}
.contentBlok{
  scroll-margin-top: 50px;
  padding: 50px 10px;
  background:#2ecc71;

  
  }
</style>